import img6 from '../.././Image/img13.png'
import img12 from '../.././Image/img12.png'
import img5 from '../.././Image/img5.PNG'
import img20 from '../.././Image/IMG_3192.PNG'

function Website() {
    return (
        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow h-[300px] w-[300px]">
                    <img
                        src={img20}
                        className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                {/* <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow h-[300px] w-[300px]">
                    <img
                        src={img6}
                        className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div> */}

                {/* <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow h-[300px] w-[300px]">
                    <img
                        src={img5}
                        className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div> */}
                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow h-[300px] w-[300px]">
                    <img
                        src={img12}
                        className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>
                  <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow h-[300px] w-[300px]">
                    <img
                        src={img6}
                        className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>


            </div>


            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

                <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">


                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Structure Guide</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A document that outlines the complete layout of the website header, footer,
                            navigation flow, page structure, sections, and content placement rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Content Guidelines</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Formal rules for writing, formatting, and organizing website content to ensure
                            clarity, consistency, SEO optimization, and user-friendly communication.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Design Framework</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Detailed instructions on website UI elements, spacing, grids, colors, buttons,
                            forms, images, banners, and overall visual presentation.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Web Style Guide</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Defines the website’s tone, writing style, icon usage, typography scales, and
                            do’s & don’ts for a unified brand experience.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Web UI/UX Standards Manual</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A guide for designing UI components, animations, interactions, responsive
                            behavior, and accessibility rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Branding Handbook</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A compact overview of how the brand appears on the website — logo use, color
                            application, visual hierarchy, and messaging style.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Component Library</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Includes reusable UI components like buttons, grids, forms, navigation bars, and
                            interactive elements.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Identity Manual</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Explains the identity of the website — layouts, templates, typography, image
                            treatment, and digital brand behavior.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Web Design System & Brand Identity</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A combined manual merging website branding rules with a structured design system
                            for product websites.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Website Strategy Guide</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A strategic document focusing on goals, user journey planning, audience, SEO,
                            and execution roadmap.
                        </p>
                    </div>


                </div>

            </div>

        </>
    );
}
export default Website;